
import EmojiHappy from "../../../assets/filled/EmojiHappy.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmojiHappyIcon({ className, dataTestid = "EmojiHappyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EmojiHappy data-testid={dataTestid} className={classes} {...rest} />
  );
}
